//Parroquia Monagas
const munAcostaMonagas = ['Capital Acosta', 'San Francisco'];
const munAguasay = ['Aguasay'];
const munBolívar = ['Bolívar'];
const munCaripe = [
  'Caripe',
  'El Guácharo',
  'La Guanota',
  'Sabana de Piedra',
  'San Agustín',
  'Teresén',
];
const munCedeño = ['Cedeño ', 'Areo ', 'San Félix', 'Viento Fresco'];
const munEzequielZamoraMonagas = ['Capital Ezequiel Zamora', 'El Tejero'];
const munLibertadorMonagas = [
  'Libertador ',
  'Chaguaramas ',
  'Las Alhuacas ',
  'Tabasca ',
];
const munMaturín = [
  'Capital Maturín ',
  'Alto de los Godos',
  'Boquerón',
  'Las Cocuizas',
  'San Simón',
  'Santa Cruz',
  'El Corozo',
  'El Furrial',
  'Jusepín',
  'La Pica',
  'San Vicente',
];
const munPiarMonagas = [
  'Piar',
  'Aparicio',
  'Chaguaramal',
  'El Pinto',
  'Guanaguana',
  'La Toscana',
  'Taguaya',
];
const munPunceres = ['Punceres', 'Cachipo'];
const munSantaBárbara = ['Santa Bárbara'];
const munSotillo = ['Sotillo', 'Los Barrancos de Fajardo'];
const munUracoa = ['Uracoa'];

export const esMonagas = [
  {
    municipio: 'Acevedo Miranda',
    parroquias: munAcostaMonagas,
  },
  {
    municipio: 'Aguasay',
    parroquias: munAguasay,
  },
  {
    municipio: 'Bolívar',
    parroquias: munBolívar,
  },
  {
    municipio: 'Caripe',
    parroquias: munCaripe,
  },

  {
    municipio: 'Cedeño',
    parroquias: munCedeño,
  },
  {
    municipio: 'Ezequiel Zamora Monagas',
    parroquias: munEzequielZamoraMonagas,
  },
  {
    municipio: 'Libertador Monagas',
    parroquias: munLibertadorMonagas,
  },
  {
    municipio: 'Maturín',
    parroquias: munMaturín,
  },
  {
    municipio: 'Piar',
    parroquias: munPiarMonagas,
  },
  {
    municipio: 'Punceres',
    parroquias: munPunceres,
  },
  {
    municipio: 'Santa Bárbara',
    parroquias: munSantaBárbara,
  },
  {
    municipio: 'Sotillo',
    parroquias: munSotillo,
  },
  {
    municipio: 'Uracoa',
    parroquias: munUracoa,
  },
];
